import React from 'react';
import { useOverlayContext } from '../../OverlayContext';
import OverlayControl from '../../../../../Helper/OverlayControl';
import StampIcon from '../../../../../../Das/StampIcon';
import cn from 'classnames';
import { getDeviationUrl } from '../../../../../_helpers';
import overlayIconStyles from '../OverlayIcons.scss';
import s from './DasControl.scss';
var DasControl = function (_a) {
    var _b, _c, _d;
    var deviation = _a.deviation, className = _a.className, iconClassName = _a.iconClassName, statClassName = _a.statClassName, isPermanentIcon = _a.isPermanentIcon, size = _a.size;
    var showStats = useOverlayContext(deviation).showStats;
    return (React.createElement("a", { href: "" + getDeviationUrl(deviation) + (((_b = deviation.digitalAsset) === null || _b === void 0 ? void 0 : _b.hasEditions) ? '?das=true' : ''), className: overlayIconStyles['icon-button'] },
        React.createElement(OverlayControl, { className: s['root'], showStats: showStats, stat: ((_c = deviation.digitalAsset) === null || _c === void 0 ? void 0 : _c.numEditions)
                ? (_d = deviation.digitalAsset) === null || _d === void 0 ? void 0 : _d.numEditions
                : 1, statClassName: statClassName, showFlipped: false },
            React.createElement(StampIcon, { size: size, withPadding: false, disableDefaultColors: true, className: cn(overlayIconStyles['icon'], isPermanentIcon && overlayIconStyles['permanent'], iconClassName) }))));
};
DasControl.displayName = 'DasControl';
export default DasControl;
//# sourceMappingURL=DasControl.js.map